export class HTMLRow {
  label?: string;
  html?: string;
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/htmlRow.ts